export type DesignTemplateData = {
  e2DesignId: string;
  e2DesignTitle: string;
  e1TemplateId: string;
};

/**
 * Components Props
 */

export type DesignAIModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export type DesignAIModalContentProps = {
  onClickBack: () => void;
};

/**
 * Types for the Error handler
 */
export enum ChatErrorTypes {
  BAD_REQUEST = '400',
  INTERNAL_SERVER_ERROR = '500',
  INVALID_INFOGRAPHIC_STATE = 'invalid_infographic_state',
  USER_OVERLIMIT_TOAST = 'overlimit_toast',
  USER_OVERLIMIT = 'overlimit',
}
